<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4703_7591)">
      <mask
        id="mask0_4703_7591"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="3"
        y="3"
        width="18"
        height="19"
      >
        <path
          d="M21 3.26172H3V21.2617H21V3.26172Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_4703_7591)">
        <path
          d="M20.64 12.4659C20.64 11.8278 20.5828 11.2141 20.4764 10.625H12V14.1064H16.8436C16.635 15.2314 16.0009 16.1846 15.0478 16.8228V19.0809H17.9564C19.6582 17.5141 20.64 15.2068 20.64 12.4659Z"
          fill="#4285F4"
        />
        <path
          d="M11.9998 21.2617C14.4298 21.2617 16.467 20.4557 17.9561 19.0812L15.0475 16.8231C14.2416 17.3631 13.2107 17.6821 11.9998 17.6821C9.65565 17.6821 7.6716 16.0989 6.96384 13.9717H3.95703V16.3035C5.43798 19.2449 8.4816 21.2617 11.9998 21.2617Z"
          fill="#34A853"
        />
        <path
          d="M6.96405 13.9715C6.78405 13.4315 6.68181 12.8547 6.68181 12.2615C6.68181 11.6683 6.78405 11.0915 6.96405 10.5515V8.21973H3.95724C3.34776 9.43473 3 10.8093 3 12.2615C3 13.7138 3.34776 15.0883 3.95724 16.3033L6.96405 13.9715Z"
          fill="#FBBC04"
        />
        <path
          d="M11.9998 6.84129C13.3211 6.84129 14.5075 7.29534 15.4402 8.18715L18.0216 5.60577C16.463 4.15353 14.4257 3.26172 11.9998 3.26172C8.4816 3.26172 5.43798 5.27853 3.95703 8.21991L6.96384 10.5517C7.6716 8.42448 9.65565 6.84129 11.9998 6.84129Z"
          fill="#E94235"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4703_7591">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.261719)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
